document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-icons-display').forEach((container) => {
    const paragraph = container.querySelector('p');
    if (!paragraph || paragraph.dataset.enhanced === 'true') return;

    const parts = paragraph.innerHTML
      .split(/<br\s*\/?>/i)
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length < 4) return;

    paragraph.dataset.enhanced = 'true';
    paragraph.classList.add('cid--grid');

    const icon = '/cdn/shop/files/Vector_8.png?v=1755560863';
    paragraph.innerHTML = `
      <span class="cid-item"><img src="${icon}" alt="" class="cid-icon">${parts[0]}</span>
      <span class="cid-item"><img src="${icon}" alt="" class="cid-icon">${parts[2]}</span>
      <span class="cid-item"><img src="${icon}" alt="" class="cid-icon">${parts[1]}</span>
      <span class="cid-item"><img src="${icon}" alt="" class="cid-icon">${parts[3]}</span>
    `;
  });
});
